const corporateChauffeur = {
  // HeroSection
  'corporateChauffeur.hero.homeLink': 'ホーム',
  'corporateChauffeur.hero.corporateLink': '法人研修',
  'corporateChauffeur.hero.currentPage': 'ハイヤー・送迎向け',
  'corporateChauffeur.hero.title': 'ハイヤー・送迎向け 法人研修',
  'corporateChauffeur.hero.titleEn': 'FOR CHAUFFEUR & VIP TRANSPORT',
  'corporateChauffeur.hero.lead': '乗降の所作と車内の気配りを、日本の執事学校の執事のもてなしに基づくビジネスマナー研修で磨くプログラムです。',
  'corporateChauffeur.hero.cta': 'この業種で相談する',
  'corporateChauffeur.hero.imgAlt': 'ドアを丁寧に開けてVIPを出迎えるハイヤードライバー',
  'corporateChauffeur.hero.badge1': '乗降・ドアサービスの所作を統一',
  'corporateChauffeur.hero.badge2': '出張型で貴社の営業所・研修室へ',
  'corporateChauffeur.hero.badge3': '執事養成課程と同一の講師陣',

  // PainPoints
  'corporateChauffeur.pain.label': 'CHALLENGES',
  'corporateChauffeur.pain.title': 'こんな課題をお持ちではありませんか',
  'corporateChauffeur.pain.titleEn': 'Common Challenges',
  'corporateChauffeur.pain.lead': '運転技術が高くても、乗降の所作や車内の気配りで差が出ます。役員・VIP送迎に求められる品格を、感覚ではなく「型」として教えられる体制が必要です。',
  'corporateChauffeur.pain.0': '運転技術は高いが、乗降の所作やお声がけにばらつきがある',
  'corporateChauffeur.pain.1': '役員・VIP送迎で求められる距離感と守秘を体系的に教えられていない',
  'corporateChauffeur.pain.2': '手荷物の扱いやドアサービスの作法が個人任せ',
  'corporateChauffeur.pain.3': '空港送迎・接待送迎での待機・お出迎えの品格を上げたい',

  // WhyButlerWorks
  'corporateChauffeur.why.label': 'WHY BUTLER METHOD',
  'corporateChauffeur.why.title': 'なぜ執事の作法がショーファーサービスに効くのか？',
  'corporateChauffeur.why.titleEn': 'Why the Butler Approach Works',
  'corporateChauffeur.why.lead1': '執事はもともと主の移動に付き添い、ドアの開閉・手荷物・車中の気配りを担ってきました。ショーファーサービスと本質的に同じ役割です。',
  'corporateChauffeur.why.lead2': '本研修が提供するのは、執事が体系化してきた「移動のもてなしの型」を、現場で再現できる形でお伝えすることです。',
  'corporateChauffeur.why.0.title': '執事の所作とショーファーサービスの本質的な一致',
  'corporateChauffeur.why.0.desc': '執事はもともと、主の移動に付き添い、ドアの開閉、手荷物の取り扱い、車中の気配りを担ってきました。これはショーファーサービスが求める所作と本質的に同じであり、全業種の中で最も親和性が高い領域です。本研修では、執事が体系化してきた「移動のもてなしの型」を、現場で再現できる形でお伝えします。',
  'corporateChauffeur.why.1.title': '守秘と距離感を技術として教えられる',
  'corporateChauffeur.why.1.desc': 'ハイヤー・送迎の現場では、乗車される方との適切な距離感と守秘が不可欠です。「親しみ」と「踏み込みすぎない品格」の線引きは、経験則に頼りがちですが、執事の接遇理論では明確な基準として言語化されています。本研修では、会話の切り出し方から沈黙の許容まで、具体的な技術として指導します。',
  'corporateChauffeur.why.2.title': '車という限られた空間での気配りを実技で磨く',
  'corporateChauffeur.why.2.desc': '車内という閉じられた空間では、温度・音・香り・会話のひとつひとつが乗り心地を左右します。座学ではなく実技中心の訓練を通じて、受講者の身体に「先回りの気配り」を染み込ませます。研修翌日から、お客様に「いつもと違う」と言われる接遇品質を目指します。',

  // RecommendedPrograms
  'corporateChauffeur.rec.label': 'RECOMMENDED',
  'corporateChauffeur.rec.title': '推奨プログラム構成',
  'corporateChauffeur.rec.titleEn': 'Program Examples for Chauffeur Services',
  'corporateChauffeur.rec.lead': '貴社の運行形態と課題に合わせて、最適な研修構成をご提案します。',
  'corporateChauffeur.rec.badge': '標準',
  'corporateChauffeur.rec.priceSuffix': '円（税込）',
  'corporateChauffeur.rec.corporateLink': '法人研修総合ページ',
  'corporateChauffeur.rec.corporateLinkText': 'モジュールの詳細は',
  'corporateChauffeur.rec.corporateLinkSuffix': 'をご覧ください。',
  'corporateChauffeur.rec.0.duration': '3時間',
  'corporateChauffeur.rec.0.modules': 'M1（立ち居振る舞い・身だしなみ）＋ M2（VIP対応の原則・守秘）',
  'corporateChauffeur.rec.0.description': '送迎の現場でまず整えるべき「立ち居振る舞い」と「VIP対応の原則」を半日で集中的に学ぶ短期プランです。まずは試行的に導入したい場合や、特定の課題に絞ったブラッシュアップに適しています。',
  'corporateChauffeur.rec.1.duration': '6時間',
  'corporateChauffeur.rec.1.modules': 'M1 ＋ M2 ＋ M3（乗降・手荷物の所作実技）＋ M4（想定外対応ロールプレイング）',
  'corporateChauffeur.rec.1.description': '立ち居振る舞いからVIP対応の原則、乗降の実技、想定外対応のロールプレイングまで、ショーファーサービスの接遇基盤を1日で網羅する推奨プランです。',
  'corporateChauffeur.rec.2.duration': '月1半日×6ヶ月',
  'corporateChauffeur.rec.2.modules': '新人ドライバーの定着研修に推奨／毎月テーマを変えて段階的に習得',
  'corporateChauffeur.rec.2.description': '新たに加わるドライバーに、月1回の研修を通じて接遇の型を段階的に定着させるプログラムです。単発研修では残りにくい所作も、反復と現場フィードバックのサイクルで確実に身につきます。',

  // ScenarioTraining
  'corporateChauffeur.scenario.label': 'SCENARIOS',
  'corporateChauffeur.scenario.title': 'ハイヤー・送迎特化の演習シナリオ',
  'corporateChauffeur.scenario.titleEn': 'Chauffeur Training Scenarios',
  'corporateChauffeur.scenario.lead': '研修は実際の送迎場面を再現して行います。代表的なシナリオを三つご紹介します。',
  'corporateChauffeur.scenario.note': '※シナリオは貴社の運行形態・車両に合わせて調整できます。',
  'corporateChauffeur.scenario.0.title': '車寄せでのお出迎えと乗車',
  'corporateChauffeur.scenario.0.desc': '車寄せでの停車位置とタイミング、後部ドアの開閉所作、手荷物の預かり方とトランクへの収納所作、乗車時の一言と目線の配り方、傘の差し出し方まで、一連の所作を反復練習します。お客様が最初に感じる「迎え入れの質」に重点を置き、所作の一つひとつに意味と品格を宿らせる技術を習得します。',
  'corporateChauffeur.scenario.1.title': '車内での気配り',
  'corporateChauffeur.scenario.1.desc': '温度・音・香りの先回り確認、会話の切り出し方と距離感、沈黙の許容とタイミング、乗客の酔いや体調への配慮、降車時のタイミングとお声がけまで、車内という限られた空間での気配りを訓練します。特に役員・VIP送迎で求められる「察する力」を、具体的なチェックリストとロールプレイングで磨きます。',
  'corporateChauffeur.scenario.2.title': '空港・接待送迎',
  'corporateChauffeur.scenario.2.desc': 'フライト遅延時の待機の品格と情報収集、複数名のお出迎え時の優先順位と動線、同伴者・お子様への配慮、手荷物の数が多い場合の捌き方、到着ロビーから車両までのご案内所作までをロールプレイングで訓練します。不測の事態にも慌てず対応できる「型」を身につけます。',

  // TargetRoles
  'corporateChauffeur.target.label': 'TARGET',
  'corporateChauffeur.target.title': '対象職種・推奨人数',
  'corporateChauffeur.target.titleEn': 'Target Roles & Capacity',
  'corporateChauffeur.target.lead': 'ハイヤードライバーから空港送迎担当まで、お客様と直接接するすべての職種の皆様にご受講いただけます。',
  'corporateChauffeur.target.capacity': '推奨12名まで',
  'corporateChauffeur.target.capacityNote': '超過する場合は2班制等をご提案します。出張型で貴社の営業所・研修室にて実施します。実車を用いた実技にも対応します。',
  'corporateChauffeur.target.role0': 'ハイヤー・専属ドライバー',
  'corporateChauffeur.target.role1': '役員・VIP送迎担当',
  'corporateChauffeur.target.role2': '空港送迎担当',
  'corporateChauffeur.target.role3': '運行管理者',
  'corporateChauffeur.target.role4': '新人教育担当',

  // PricingTable
  'corporateChauffeur.pricing.label': 'PRICING',
  'corporateChauffeur.pricing.title': '料金プラン',
  'corporateChauffeur.pricing.titleEn': 'Transparent Pricing',
  'corporateChauffeur.pricing.lead': 'すべて税込価格での明確な料金体系です。貴社のご予算と目標に合わせて最適なプランをお選びいただけます。',
  'corporateChauffeur.pricing.colPlan': 'プラン',
  'corporateChauffeur.pricing.colDuration': '時間',
  'corporateChauffeur.pricing.colPrice': '料金（税込）',
  'corporateChauffeur.pricing.colNote': '内容',
  'corporateChauffeur.pricing.badge': '標準',
  'corporateChauffeur.pricing.priceSuffix': '円',
  'corporateChauffeur.pricing.conditionsTitle': '共通条件',
  'corporateChauffeur.pricing.corporateLinkText': '継続プログラム・覆面サービス診断などの全メニューは',
  'corporateChauffeur.pricing.corporateLink': '法人研修総合ページ',
  'corporateChauffeur.pricing.corporateLinkSuffix': 'をご覧ください。',
  'corporateChauffeur.pricing.cta': '研修について問い合わせる',
  'corporateChauffeur.pricing.plan0.name': '半日プラン',
  'corporateChauffeur.pricing.plan0.duration': '3時間',
  'corporateChauffeur.pricing.plan0.note': '2モジュール選択',
  'corporateChauffeur.pricing.plan1.name': '1日プラン',
  'corporateChauffeur.pricing.plan1.duration': '6時間',
  'corporateChauffeur.pricing.plan1.note': '4モジュール選択',
  'corporateChauffeur.pricing.plan2.name': '継続プログラム',
  'corporateChauffeur.pricing.plan2.duration': '月1半日×6ヶ月',
  'corporateChauffeur.pricing.plan2.note': '新人定着研修に推奨',
  'corporateChauffeur.pricing.cond.dispatch': '出張時の交通費・宿泊費は実費別途',
  'corporateChauffeur.pricing.cond.capacity': '推奨12名まで（超過は2班制等をご提案）',
  'corporateChauffeur.pricing.cond.vehicle': '実車を用いた実技は貴社車両を使用します。会場と車両の条件をヒアリング時にお知らせください。',
  'corporateChauffeur.pricing.cond.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporateChauffeur.pricing.cond.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',

  // FlowSteps
  'corporateChauffeur.flow.label': 'FLOW',
  'corporateChauffeur.flow.title': 'ご利用の流れ',
  'corporateChauffeur.flow.titleEn': 'From Inquiry to Results',
  'corporateChauffeur.flow.lead': 'お問い合わせから実施後レポートまで、5つのステップで進めます。',
  'corporateChauffeur.flow.step0.title': 'お問い合わせ',
  'corporateChauffeur.flow.step0.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporateChauffeur.flow.step1.title': 'ヒアリング',
  'corporateChauffeur.flow.step1.desc': '対象人数・課題・希望時期・車両台数などをオンラインまたはお電話で伺います。',
  'corporateChauffeur.flow.step2.title': '提案・お見積り',
  'corporateChauffeur.flow.step2.desc': 'ヒアリング内容をもとに、貴社の運行形態に最適な研修プログラムとお見積りをご提案します。',
  'corporateChauffeur.flow.step3.title': '実施',
  'corporateChauffeur.flow.step3.desc': '出張または来校にて研修を実施します。出張型では貴社の営業所・研修室で実車を用いた実技訓練を行います。',
  'corporateChauffeur.flow.step4.title': '実施後レポート',
  'corporateChauffeur.flow.step4.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',

  // ContactForm
  'corporateChauffeur.contact.label': 'CONTACT',
  'corporateChauffeur.contact.title': 'お問い合わせ',
  'corporateChauffeur.contact.titleEn': 'Inquiry Form',
  'corporateChauffeur.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporateChauffeur.contact.phoneText': 'フォームのほか、お電話',
  'corporateChauffeur.contact.phoneOr': 'またはメール',
  'corporateChauffeur.contact.phoneAccept': 'でも承ります。',
  'corporateChauffeur.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporateChauffeur.contact.company': '会社名',
  'corporateChauffeur.contact.department': '部署・役職',
  'corporateChauffeur.contact.name': 'ご担当者名',
  'corporateChauffeur.contact.nameRequired': '必須',
  'corporateChauffeur.contact.namePlaceholder': '例: 執事 太郎',
  'corporateChauffeur.contact.nameError': 'ご担当者名は必須です',
  'corporateChauffeur.contact.email': 'メールアドレス',
  'corporateChauffeur.contact.emailRequired': '必須',
  'corporateChauffeur.contact.emailPlaceholder': '例: taro@example.com',
  'corporateChauffeur.contact.emailError': 'メールアドレスは必須です',
  'corporateChauffeur.contact.emailInvalidError': '有効なメールアドレスを入力してください',
  'corporateChauffeur.contact.phone': '電話番号',
  'corporateChauffeur.contact.phoneRequired': '必須',
  'corporateChauffeur.contact.phonePlaceholder': '例: 090-1234-5678',
  'corporateChauffeur.contact.phoneError': '電話番号は必須です',
  'corporateChauffeur.contact.category': '業態・カテゴリ',
  'corporateChauffeur.contact.categoryRequired': '必須',
  'corporateChauffeur.contact.categoryError': '業態をお選びください',
  'corporateChauffeur.contact.format': '希望形式',
  'corporateChauffeur.contact.participants': '想定人数',
  'corporateChauffeur.contact.participantsPlaceholder': '例: 10名',
  'corporateChauffeur.contact.timeline': '検討時期',
  'corporateChauffeur.contact.timelinePlaceholder': '例: 来月、今期中、未定',
  'corporateChauffeur.contact.message': 'ご相談内容（任意）',
  'corporateChauffeur.contact.messagePlaceholder': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporateChauffeur.contact.messageMax': '500文字以内で入力してください',
  'corporateChauffeur.contact.submitError': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporateChauffeur.contact.submitting': '送信中...',
  'corporateChauffeur.contact.submit': 'この内容で送信する',
  'corporateChauffeur.contact.companyPlaceholder': '例: 株式会社〇〇',
  'corporateChauffeur.contact.departmentPlaceholder': '例: 運行管理部',
  'corporateChauffeur.contact.catOpt0': '選択してください',
  'corporateChauffeur.contact.catOpt1': 'ハイヤー',
  'corporateChauffeur.contact.catOpt2': '役員送迎',
  'corporateChauffeur.contact.catOpt3': '空港送迎',
  'corporateChauffeur.contact.catOpt4': '専属ドライバー',
  'corporateChauffeur.contact.catOpt5': 'その他',
  'corporateChauffeur.contact.fmtOpt0': '選択してください',
  'corporateChauffeur.contact.fmtOpt1': '出張',
  'corporateChauffeur.contact.fmtOpt2': '来校',
  'corporateChauffeur.contact.fmtOpt3': '未定',

  // FAQSection
  'corporateChauffeur.faq.label': 'FAQ',
  'corporateChauffeur.faq.title': 'よくあるご質問',
  'corporateChauffeur.faq.titleEn': 'Frequently Asked Questions',
  'corporateChauffeur.faq.note': 'その他のご質問はフォームよりお寄せください',
  'corporateChauffeur.faq.0.q': '執事の資格が取れますか？',
  'corporateChauffeur.faq.0.a': 'いいえ。執事の接遇スキルに基づくビジネスマナー研修で、資格付与はありません。受講証（参加証明）を発行できます。',
  'corporateChauffeur.faq.1.q': '実車での実技はできますか？',
  'corporateChauffeur.faq.1.a': 'はい。貴社車両を用いた乗降・ドアサービスの実技に対応します。',
  'corporateChauffeur.faq.2.q': '運転技術の指導もありますか？',
  'corporateChauffeur.faq.2.a': 'いいえ。本研修は接遇・所作・ビジネスマナーに特化し、運転技能の指導は行いません。',

  // CTASection
  'corporateChauffeur.cta.label': 'GET STARTED',
  'corporateChauffeur.cta.title': 'まずはお気軽にご相談ください',
  'corporateChauffeur.cta.lead': '実車を用いた乗降の実技にも対応します。まずは車両台数と課題をお聞かせください。',
  'corporateChauffeur.cta.sub': '貴社の運行形態やドライバーの課題をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporateChauffeur.cta.inquiry': '研修について問い合わせる',
  'corporateChauffeur.cta.courses': '個人向けコースを見る',

  // RelatedPages
  'corporateChauffeur.related.label': 'OTHER INDUSTRIES',
  'corporateChauffeur.related.title': '他の業種向けプログラム',
  'corporateChauffeur.related.titleEn': 'Training for Other Industries',
  'corporateChauffeur.related.viewLink': '詳しく見る',
  'corporateChauffeur.related.corporateBack': '法人研修総合ページへ戻る',
  'corporateChauffeur.related.coursesLink': '個人向けコース（執事養成課程）を見る',
  'corporateChauffeur.related.0.title': '自動車・モビリティ',
  'corporateChauffeur.related.0.desc': 'ブランド体験・イベントのおもてなしを高める',
  'corporateChauffeur.related.1.title': 'ホテル・旅館',
  'corporateChauffeur.related.1.desc': '開業前研修からバトラーサービスの型まで',
  'corporateChauffeur.related.2.title': '高級レジデンス',
  'corporateChauffeur.related.2.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'corporateChauffeur.related.3.title': '金融・プライベートバンク',
  'corporateChauffeur.related.3.desc': '富裕層対応の信頼を所作から築く',
  'corporateChauffeur.related.4.title': 'ラグジュアリー営業',
  'corporateChauffeur.related.4.desc': '高級車・宝飾・不動産の商談体験を設計',

  // page.tsx
  'corporateChauffeur.page.lastUpdated': '最終更新: 2026年6月13日',
};

export default corporateChauffeur;
